import { TableCell, TableHeader } from '@tiptap/extension-table';

export const parseBorderDeclaration = (element: HTMLElement): string | null => {
    const borderDeclaration = element.getAttribute('style')?.match(/(?:^|;)\s*border\s*:\s*([^;]+)\s*(?:;|$)/i);

    return borderDeclaration?.[1].trim() ?? null;
};

export const TableCellWithBorder = TableCell.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            border: {
                default: null,
                parseHTML: parseBorderDeclaration,
                renderHTML: ({ border }) => (border ? { style: `border: ${border}` } : {}),
            },
        };
    },
});

export const TableHeaderWithBorder = TableHeader.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            border: {
                default: null,
                parseHTML: parseBorderDeclaration,
                renderHTML: ({ border }) => (border ? { style: `border: ${border}` } : {}),
            },
        };
    },
});
